module.exports = __webpack_public_path__ + "assets/img/bg-card-mobile.dc87f131bf21e4307275c7e533411268.svg";